import axiosInstance from "../../../../api/axiosConfig";

export const addBannerImage = (data: any) => {
  return axiosInstance.post("/admin/banner-images", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getBannerImage = (id: string) => {
  return axiosInstance.get(`/admin/banner-images/${id}`);
};

export const updateBannerImage = (id: string, data: any) => {
  return axiosInstance.patch(`/admin/banner-images/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
